// API V4 ROUTES
import { event as v4Event } from './v4/event'
import { eventCollection } from './v4/eventcollection'
import { guest } from './v4/guest'
import { location } from './v4/location'
import { otp } from './v4/otp'
import { performer as v4Performer } from './v4/performer'
import { ticket } from './v4/ticket'
import { transaction } from './v4/transaction'
import { typeticket } from './v4/typeticket'
import { typeticketcollection } from './v4/typeticketcollection'
import { wallet } from './v4/wallet'
// API V3 ROUTES
import { analytics } from './analytics'
import { checkout } from './checkout'
import { collection } from './collection'
import { event } from './event'
import { home } from './home'
import { notifications } from './notifications'
import { payments } from './payments'
import { performer } from './performer'
import { promoter } from './promoter'
import { purchase } from './purchase'
import { receipt } from './receipt'
import { search } from './search'
import { servertoserver } from './servertoserver'
import { support } from './support'
import { tickets } from './tickets'
import { users } from './users'
import { vault } from './vault'
import { venue } from './venue'

export const ApiEndpoint = {
  analytics,
  collection,
  checkout,
  event,
  home,
  notifications,
  payments,
  performer,
  promoter,
  purchase,
  receipt,
  search,
  servertoserver,
  support,
  tickets,
  users,
  vault,
  venue,
  v4: {
    event: v4Event,
    eventCollection,
    guest,
    location,
    otp,
    performer: v4Performer,
    wallet,
    ticket,
    transaction,
    typeticket,
    typeticketcollection,
  },
}
